import { useMutation } from 'react-query';
import request from '../../../helpers/request';
import { createOptions } from './utls';

const addTask = async (values) => {
  const { workerId, requestId, fromDate, toDate } = values;
  const data = await request.post(
    `/Request/add_task`,
    { workerId, requestId, fromDate, toDate },
    'При добавлении заявки в календарь произошла ошибка',
    'Error'
  );

  return data;
};

const useAddTaskMutation = (options) => {
  return useMutation(({ values }) => addTask(values), createOptions(options));
};

export default useAddTaskMutation;
